const maritalStatus = [
  { label: "Never married", value: "neverMarried" },
  { label: "Married", value: "married" },
  { label: "Divorced", value: "divorced" },
  { label: "Widowed", value: "widowed" },
];
export default maritalStatus;
